import { MapContainer } from "react-leaflet";
import styled from "styled-components";

const MapBase = styled(MapContainer)`
	width: 100%;
	height: 100%;
`;

export default MapBase;
